/**
 * @namespace PerformanceAggregatorAPI
 */
window.PerformanceAggregatorAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSLPMAggregatorServer : publicConfiguration.LPMAggregatorServer;
    _protected.setApiUrl(url);

    var apiUpdatedUrl = self.apiUrl.replace('/lpm-aggregator', '').replace('gateway','lpm-aggregator');

    self.PAYROLL_SETTINGS_EXPORT_TYPE_TAG = 'EXPORT_TYPE';

    self.IS_WORKFLOW_ENABLED_LOWERCASED = 'is_workflow_enabled';

    self.PAYSHEET_AUDIT_LOG_STATUS = {
        SUCCESS: 'SUCCESS',
        FAIL: 'FAIL',
    };

    self.PAYROLL_PAYSHEET_CODES = {
        STAFFOLOGY: 'STAFFOLOGY',
        UK_GENERIC: 'UK_GENERIC',
        ADP_NEXTGEN: 'ADP_NEXTGEN',
        ADP_POSITION: 'ADP_POSITION',
        ADP: 'ADP',
        INFOSYNC: 'INFOSYNC',
        MRC_QDOBA: 'MRC_QDOBA',
        DATA_PASS: 'DATA_PASS',
        STEAK_N_SHAKE: 'STEAK_N_SHAKE',
        PAYLOCITY: 'PAYLOCITY',
        PAYLOCITY_RATE: 'PAYLOCITY_RATE',
        BENEFIT_MALL: 'BENEFIT_MALL',
        ACCUDATA: 'ACCUDATA',
        PAPERCHASE: 'PAPERCHASE',
        REALTIME: 'REALTIME',
        PAYCHEX: 'PAYCHEX',
        PAYCHEX_FLEX: 'PAYCHEX_FLEX',
        CERIDIAN: 'CERIDIAN',
        VALIANT: 'VALIANT',
        PACIFIC_CATCH: 'PACIFIC_CATCH',
        PAYCOM: 'PAYCOM',
        FOURTH: 'FOURTH',
        ISOLVED: 'ISOLVED',
        LAWSON: 'LAWSON',
        SHIFTABLE_HR: 'SHIFTABLE_HR',
        PROLIANT_GOODMAN: 'PROLIANT_GOODMAN',
        PROLIANT: 'PROLIANT',
        BENEFIT_MALL_RATE: 'BENEFIT_MALL_RATE',
        NETCHEX: 'NETCHEX',
        PAYCOR: 'PAYCOR',
        AAP: 'AAP',
        VISMA: 'VISMA',
        WORKDAY_SHAKE_SHACK: 'WORKDAY_SHAKE_SHACK',
        MITRA_INFOSYNC: 'MITRA_INFOSYNC',
        PAYCOM_TIMECARD: 'PAYCOM_TIMECARD',
        SAGE_50: 'SAGE_50',
        ZELLIS: 'ZELLIS',
        ENGAGE: 'ENGAGE',
        ADP_NEXTGEN_SHIFT: 'ADP_NEXTGEN_SHIFT',
    };

    self.PAYSHEET_AUDIT_LOG_ACTION = {
        EXPORT: 'EXPORT',
    };

    self.EXPORT_TYPES = {
        client: 'CLIENT',
        sftp: 'SFTP',
    }

    self.CLOCK_STATUS = {
        CONFIRMED: 'CONFIRMED',
    };

    self.PAYSHEET_PAY_PERIOD_STATUS = {
        CLOSED: 'CLOSED',
        OPEN: 'OPEN',
        IN_PROGRESS:'IN_PROGRESS',
        SENT: 'SENT',
        OPENING: 'OPENING',
        CLOSING: 'CLOSING',
    };

    self.PAYRUN_STATUS = {
        INITIAL: {
            code: 'INITIAL',
        },
        PAID: {
            code: 'PAID',
        },
        ALL: {
            code: 'ALL',
        },
    };

    self.PAYROLL_SETTINGS_KEYS = {
        EXPORT_TYPE: 'EXPORT_TYPE',
    };

    self.TRONC_MODE = {
        POINTS: 'POINTS',
    };

    self.TRONC_POINT_PERIOD_TYPE = {
        PAY_PERIOD: 'PAY_PERIOD',
    };
    self.PAYSHEET_ATTRIBUTE_TYPE = {
        MONETARY: 'MONETARY',
        SCALAR: 'SCALAR',
    };

    self.PENSIONS_CONTRIBUTION = 'pensions_contribution';

    self.getTotalTips = function (brandId, date) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/tips', 'GET', {day: date}).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPaysheetTotalTips = function (brandId, paysheetTypeId, paysheetId, date) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypeId + '/paysheets/' + paysheetId + '/tips', 'GET', {date: date}).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLatestClosedPayPeriod = function (brandId, payType, statuses) {
        var deferred = $q.defer();

        var payload = {
            pay_types: payType,
            statuses: statuses
        };

        _protected.request('brands/' + brandId + '/paysheet_types/paysheets/latest', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPaysheetsWithinPeriod = function (brandId, start_date, payType) {
        var deferred = $q.defer();

        var params = {
            start_date: start_date,
            pay_types: payType,
        };

        _protected.request('brands/' + brandId + '/paysheet_types/paysheets', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.distributePaysheetTips = function (brandId, paysheetTypeId, paysheetId, tips) {
        var deferred = $q.defer();

        var payload = {
            tips: tips
        };

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypeId + '/paysheets/' + paysheetId + '/tips/distribute', 'POST', payload).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getFireRollCallManagers = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/fire_roll_call/subscribers', 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.users);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getFireRollCallManagerLocations = function (brandId, managerId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/fire_roll_call/subscribers/' + managerId + '/permitted_brands', 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.brands);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateFireRollCallManagers = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/fire_roll_call/subscribers', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getPOSSyncSettings = function (brandId, posCode) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/'+  posCode +'/settings', 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.settings);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.getPaysheetSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/paysheets/settings', 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPOSSetting = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/pos', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandWeeklySalesForecast = function (brandId, days) {
        var deferred = $q.defer();

        var params = {};

        if (days && days.length) {
            params['days'] = days;
        } else {
            deferred.reject("Cannot send an empty days array!");
        }

        _protected.request('brands/' + brandId + '/stats/forecast/week', 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.getEmployeePOS = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/info", "GET")
            .then(function (res) {
                    if (res && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.updateEmployeePOS = function (brandId, userId, POS_Id) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }


        _protected.request('brands/' + brandId + '/users/' + userId + '/info', 'PUT', POS_Id)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;

    };

    //Brand TimeSheet
    //Brand Timesheet / Get brand timesheet
    self.getBrandTimesheet = function (brandId, type, day) {
        var deferred = $q.defer();

        var params = {
            type: type,
            day: day
        };

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets', 'GET', params, false).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getTimesheetRetrievalSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/timesheets/retrieval_settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

      self.distributeTimesheetTips = function (brandId, date, tips) {
        var deferred = $q.defer();
        var payLoad = {};

        if (tips) {
            payLoad['tips'] = tips;
        }

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/tips/distribute?date=' + date, 'POST', payLoad).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Brand punch management
    //Brand punch management / Get brand punch data
    self.getBrandPunchClocks = function (brandId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request('brands/' + brandId + '/punch', 'GET', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    /**
     * clock out
     * @param brandId
     */
    self.clockOut = function (brandId, userId, clockId, clockEditReason, clockOutActionReason) {
        var deferred = $q.defer();

        var params = {};

        if (clockEditReason) {
            params['clock_edit_reason'] = {
                id: clockEditReason.id
            };
        }

        if (clockOutActionReason) {
            params['clock_out_action'] = {
                reason: clockOutActionReason
            };
        }

        _protected.request('brands/' + brandId + '/punch/users/' + userId + "/clocks/" + clockId + "/clock_out", 'POST', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * Edit Clock for punch management
     * @param brandId
     * @param userId
     * @param clockId
     */
    self.editClock = (brandId, userId, clockId, clockObj) => {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/punch/users/' + userId + "/clocks/" + clockId, 'PUT', clockObj).then((res) => {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * End break
     * @param brandId
     * @param userId
     * @param clockId
     * @param breakId
     */
    self.endBreak = function (brandId, userId, clockId, breakId, clockEditReason) {
        var deferred = $q.defer();

        var params = {};

        if (clockEditReason) {
            params['clock_edit_reason'] = {
                id: clockEditReason.id
            };
        }

        _protected.request('brands/' + brandId + '/punch/users/' + userId + "/clocks/" + clockId + "/breaks/" + breakId + "/end_break", 'POST', params)
            .then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.editBreakOut = function (brandId, userId, clockId, breakId, breakEndTime) {
        var deferred = $q.defer();
        var payload = {};

        payload['break'] = {
            end_time: breakEndTime
        };

        _protected.request('brands/' + brandId + '/punch/users/' + userId + "/clocks/" + clockId + "/breaks/" + breakId, 'PUT', payload)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPaysheetStatus = function (brandId, paysheetTypesId, paysheetId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + '/status', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPaysheetAuditLogs = function (brandId, paysheetTypesId, paysheetId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + '/audit_logs', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPaySheetBonusData = function (brandId, paysheetId, paysheetTypesId) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + '/bonus', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.applyPaySheetBonusData = function (brandId, paysheetId, paysheetTypesId, payload) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + '/bonus/calculate', 'POST', payload)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    const [cachedGetPaysheetTypes] = cacheService.cache(async (brandId, detailed) => {
        const params = detailed ? { mode: 'DETAILED' } : {};
        const res = await _protected.request(`brands/${brandId}/paysheet_types`, 'GET', params);
        if (res.status === 200 && res?.data.data) {
            return res.data.data;
        } else {
            throw new Error('Invalid response');
        }
    });

    self.getPaysheetTypes = cachedGetPaysheetTypes;

    self.getPaysheetTypeSettings = function (brandId, paysheetTypeId) {
        var deferred = $q.defer();
        var params = {};

        _protected.request('brands/' + brandId + '/paysheet_types/' + paysheetTypeId + '/settings', 'GET', params)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Brand Paysheet
    //Brand Paysheet / Get brand pay periods
    self.getBrandPayperiods = function (brandId, limit, offset, paysheetTypesId) {
        var deferred = $q.defer();

        var params = {
            limit: limit || 6,
            offset: offset || 0
        };

        _protected.request('brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets', 'GET', params).then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err, param2, param3) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * Getting brand pay periods without checking the user permissions
     *
     * @param brandId
     * @param limit
     * @param offset
     * @param paysheetTypesId
     * @returns {*}
     */
    self.getBrandPayPeriods = function (brandId, limit, offset, paysheetTypesId) {
        var deferred = $q.defer();

        var params = {
            limit: limit || 6,
            offset: offset || 0
        };

        _protected.request('report_generator/brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets', 'GET', params).then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err, param2, param3) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //get brand latest paysheets if more than one paysheet type
    self.getBrandLatestPaySheets = function (brandId, userId, status) {
        var deferred = $q.defer();

        if (!brandId || !userId) {
            throw 'brandId and userId are required'
        }

        _protected.request('brands/' + brandId + '/paysheet_types/users/' + userId + '/payment_types/paysheets/latest', 'GET', status)
            .then(function (res) {
            if (res.status === 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPayRunDatasheetAuditLogs = function (brandId, payrunTypeId, payrunId, params) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets/audit', 'GET', params)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                console.error(err);
            });

        return deferred.promise;
    };

    self.getPayRunDatasheetErrors = function (brandId, payrunTypeId, payrunId, paysheetId) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets/'+ paysheetId +'/errors', 'GET')
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                console.error(err);
            });

        return deferred.promise;
    };

    self.getPayRunDatasheetStatus = function (brandId, payrunTypeId, payrunId, params) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets/status', 'GET', params)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
            });

        return deferred.promise;
    };

    self.openPayRunDatasheet = function (brandId, payrunTypeId, payrunId, paysheetId) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId || !paysheetId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets/' + paysheetId + "/open", 'POST')
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.closePayRunDatasheet = function (brandId, payrunTypeId, payrunId, paysheetId) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId || !paysheetId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets/' + paysheetId + "/close", 'POST')
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.downloadPayslips = function (brandId, payrunTypeId, payrunId, payload) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/payslips/export', 'POST', payload)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get paysheet
     * @param brandId
     * @param paysheetId
     * @param paysheetTypesId
     */
    self.getPaysheet = function (brandId, paysheetId, paysheetTypesId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request(apiUpdatedUrl +'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId, 'GET', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * get Pay Periods Statuses
     * @param brandId
     * @param userId
     * @param params {start_data,end_date}
     */
    self.getPayPeriodsStatuses = function (brandId, userId, params) {
        var deferred = $q.defer();
        params = params || {};
        _protected.request('brands/' + brandId + '/users/' + userId + '/paysheets', 'GET', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * closes paysheet
     * @param brandId
     * @param paysheetId
     */
    self.closePaysheet = function (brandId, paysheetTypeId, paysheetId) {
        var deferred = $q.defer();

        var params = {};

        if (!self.closingPaysheet) {
            self.closingPaysheet = true;

            _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypeId + '/paysheets/' + paysheetId + "/close", 'POST', params).then(function (res) {
                self.closingPaysheet = false;
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                self.closingPaysheet = false;
                deferred.reject(err);
            });
        }

        return deferred.promise;
    };

    /**
     * Open paysheet
     * @param brandId
     * @param paysheetId
     */
    self.openPaysheet = function(brandId, paysheetTypeId, paysheetId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypeId + '/paysheets/' + paysheetId + "/open", 'POST', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * export paysheet
     * @param brandId
     * @param paysheetId
     * @param paysheetTypesId
     * @param exportTarget "PAYROLL" OR "RESTAURANT_365"
     */
    self.exportPaysheet = function (brandId, paysheetId, paysheetTypesId, exportTarget, exportChannel) {
        var deferred = $q.defer();

        var params = {};
        params['target'] = exportTarget || "PAYROLL";
        params['export_channel'] = exportChannel || "CLIENT";

        if (!self.exporting) {
            self.exporting = true;

            _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + "/export", 'POST', params).then(function (res) {
                self.exporting = false;
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                self.exporting = false;
                deferred.reject(err);
            });
        }

        return deferred.promise;
    };

    /**
     * Save payroll attribute
     * @param brandId
     * @param paysheetId
     * @param attributeId
     * @param value
     */
    self.savePayrollAttribute = function (brandId, paysheetId, attributes) {
        var deferred = $q.defer();

        var params = {
            payroll_attributes: attributes
        };

        _protected.request('brands/' + brandId + '/paysheets/' + paysheetId + "/payroll_attributes", 'PUT', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.savePaysheetCustomColumns = function (brandId, paysheetTypesId, paysheetId, users) {
        var deferred = $q.defer();

        _protected.uniqueRequest(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + '/users/custom_columns', 'PUT', {users: users}).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.savePaysheetAttributes = function (brandId, paysheetTypesId, paysheetId, userId, customColumnsValues) {
        var deferred = $q.defer();

        _protected.uniqueRequest(apiUpdatedUrl + 'brands/' + brandId + '/paysheet_types/' + paysheetTypesId + '/paysheets/' + paysheetId + "/users/"+ userId, 'PUT', customColumnsValues).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Edit employee clock on a Timesheet / Update clock entry
    self.addClockEntry = function (brandId, userId, day, viewType, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks?day=' + day + '&type=' + viewType, 'POST', payload).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Edit employee clock on a Timesheet / Update clock entry
    self.updateClockEntry = function (brandId, userId, clockId, day, viewType, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '?day=' + day + '&type=' + viewType, 'PUT', payload).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Edit employee clock on a Timesheet / Update clock entry
    self.approveClock = function (brandId, userId, clockId, day, type) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '/approve' + '?day=' + day + '&type=' + type, 'POST').then(function (res) {
            if (res.status == 200 && res.data) {
                deferred.resolve(res.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Approve multiple clocks at once
    self.approveMultipleClocks = function (brandId, type, date, payload) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/approve_all?type=' + type + '&day=' + date, 'POST', payload).then(function (res) {
            if (res.status == 200 && res.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Edit employee clock on a Timesheet / Update clock entry
    self.removeClock = function (brandId, userId, clockId, day, type, shiftId, clockEditReason) {
        var deferred = $q.defer();

        var params = {
            day: day,
            type: type
        };

        if(shiftId) {
            params.shift_id = shiftId;
        }

        if (clockEditReason) {
            params['clock_edit_reason_id'] = clockEditReason.id;
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId, 'DELETE', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //mark shift with reason
    self.handleMissedClocks = function (brandId, userId, date, viewType, payload) {
        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/users/' + userId + '/clocks/missed_shift' + '?day=' + date + '&type=' + viewType, 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Brand media settings
    self.getBrandMediaSettings = function (brandId, settings) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/media', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getEmployeeUnscheduledShiftsConsents = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/shifts/consents", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Timesheet settings
    self.getEmployeeTimesheetSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request('employees/brands/' + brandId + '/timesheets/settings', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getTimesheetLockStatus = function (brandId, weeks) {
        var deferred = $q.defer();
        var params = {week_dates: weeks.join(',')};

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/status', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.lockTimesheet = function (brandId, week) {
        var deferred = $q.defer();
        var params = {
            'week_date': week
        };

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/lock', 'POST', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getClockRightToRestAudit = function(brandId, userId, clockId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '/right_to_rest/audit', 'GET')
            .then(function (data) {
            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data.right_to_rest_audit);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.unlockTimesheet = function (brandId, week) {
        var deferred = $q.defer();

        var params = {
            'week_date': week
        };

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/unlock', 'POST', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPunchManagementSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/punch/settings', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data && res.status === 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteBrandMediaSettings = function (brandId, mediaId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/media/' + mediaId, 'DELETE')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    /* brand shifts settings */
    self.getBrandShiftsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/shifts', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.updateBrandShiftsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/shifts', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    /*  brand unscheduled shifts settings */
    self.getBrandUnscheduledShiftsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/unscheduled_shifts', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.updateBrandUnscheduledShiftsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/unscheduled_shifts', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    /* brand breaks settings */
    self.getBrandBreaksSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/breaks', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.updateBrandBreaksSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/breaks', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLiveShiftSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/live_shifts', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.updateLiveShiftSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/live_shifts', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /* Set enable tips declaration settings */
    self.updateEnableTipsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/tips', 'PUT', payload).then(function (result) {

            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /*Get tips declaration settings*/
    self.getBrandTipsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/tips', 'GET').then(function (result) {

            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //
    //Brand Timesheet / Get employee timesheet
    self.getEmployeeTimesheet = function (brandId, userId, date, type) {
        var deferred = $q.defer();

        var params = {
            day: date,
            type: type
        };

        _protected.request('employees/brands/' + brandId +'/timesheets', 'GET', params).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Time card history
    self.getEmployerTimeCardHistory = function(brandId, userId, clockId, day){
        var deferred = $q.defer();

        var params = {};
        params.day = day;
        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '/history', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getEmployeeTimeCardHistory = function(brandId, clockId, day){
        var deferred = $q.defer();

        var params = {};
        params.day = day;
        _protected.request('brands/' + brandId + '/users/clocks/' + clockId + '/history', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getEditTimeCardReasons = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required');
        }

        _protected.request('brands/' + brandId + '/clock_edit_reasons', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getWaiverOnFileStatus = function (brandId, userId, day) {
        let deferred = $q.defer();
        let params = {day: day}

        if (!brandId) {
            throw new Error('Brand id is required');
        }

        if (!userId) {
            throw new Error('User id is required');
        }

        _protected.request(`brands/${brandId}/users/${userId}/waiver_on_files/status`, 'GET', params)
            .then(function (res) {
                if (res?.data?.data && res.status === 200) {
                    deferred.resolve(res.data.data.break_waiver_files || []);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * This api used to get brand time sheet adjustments settings
     * API url: https://harri3.docs.apiary.io/#reference/0/timesheet-brand-settings-employer-side/get-brand-timesheet-adjustments-settings
     *
     * @name PerformanceAggregatorAPI#getBrandTimesheetAdjustmentsSettings
     * @param brandId
     */
    self.getBrandTimesheetAdjustmentsSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required entity for this api ' + Date.now());
        }

        _protected.request('brands/' + brandId + '/settings/timesheet_adjustments', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Change time sheet adjustment settings
     * API url: https://harri3.docs.apiary.io/#reference/0/timesheet-brand-settings-employer-side/put-brand-timesheet-adjustments-settings
     *
     * @name PerformanceAggregatorAPI#setBrandTimesheetAdjustmentsSettings
     * @param brandId
     * @param adjustmentsSettings
     */
    self.setBrandTimesheetAdjustmentsSettings = function (brandId, payLoad) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/timesheet_adjustments', 'PUT', payLoad)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.brands);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get messages for employees protests this api must called if the brand has TCAF service and settings enabled
     * API url: https://harri3.docs.apiary.io/#reference/0/timesheet-brand-settings-<employee-side>/protest-messages-list
     *
     * @param brandId
     * @param userId
     * @param clockId
     * @param day
     */
    self.getClockProtestsMessages = function (brandId, userId, clockId, day) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required entity for this api ' + Date.now());
        }

        if (!userId) {
            throw new Error('user id is required entity for this api ' + Date.now());
        }

        if (!clockId) {
            throw new Error('clock id is required entity for this api ' + Date.now());
        }

        if (!day) {
            throw new Error('day is required entity for this api ' + Date.now());
        }

        var payload = {};
        payload['day'] = day;

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '/messages', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    if (Array.isArray(res.data.data.messages)) {
                        deferred.resolve(res.data.data.messages);
                    } else {
                        deferred.reject(res);
                    }
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getPaySheetTypes = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required entity for this api ' + Date.now());
        }

        _protected.request('brands/' + brandId + '/paysheet_types?mode=DETAILED' , 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTroncBreakdownSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/tips', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveTroncBreakdownSettings = function (brandId, payPeriodDistributionMode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!payPeriodDistributionMode) {
            throw "pay_period_distribution_mode: ['WEEKLY', 'FULL']";
        }

        var payload = {
            pay_period_distribution_mode: payPeriodDistributionMode
        };

        _protected.request('brands/' + brandId + '/settings/tips', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Export to Tip Network
    self.ExportTimesheetTipNetwork = function (brandId, startDate, endDate, exportTarget, exportChannel) {
        var deferred = $q.defer();
        var params = {
            start_date: startDate,
            end_date: endDate,
            export_channel: exportChannel || "CLIENT",
            target: exportTarget || "TIP_NETWORK"
        };

        _protected.uniqueRequest(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/export', 'POST', params).then(function (res) {
            if (res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUserHolidayPayDetails = function (brandId, userId, weeksCount) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            weeks_count: weeksCount
        };

        _protected.request('groups/brands/' + brandId + '/users/' + userId + '/clocks/stats', 'GET', payload)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPosId = function (brandId, teamIds) {
        var deferred = $q.defer();
        var teamIdsQuery = teamIds.join(',');
        var data = {
            fields: 'pos_id',
            team_ids: teamIdsQuery
        };

        _protected.request('brands/' + brandId + '/employees', 'GET', data).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPositionMappings = function (brandId, pos_type) {
        var deferred = $q.defer();
        var data = {};

        _protected.request('brands/' + brandId + '/services/' + pos_type + '/positions', 'GET', data).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.positions);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.getPOSPositions = function (brandId, posCode) {
        var deferred = $q.defer();
        var data = {};

        _protected.request('brands/' + brandId + '/services/' + posCode + '/settings/positions', 'GET', data).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.positions);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.savePOSPositionsMapping = function (brandId, posCode, positionPosId, positionCodes) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + posCode + '/settings/positions/' + positionPosId, 'PUT', positionCodes)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendToOracleSimphony = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/services/ORACLE_SIMPHONY_SYNC/employees', 'POST', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendToToast = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/services/TOAST_SYNC/employees', 'POST', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendToBrink = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/services/BRINK_SYNC/employees', 'POST', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSyncHistoryLogs = function (brandId, userId, groupCodes, externalChannelCodes) {
        var deferred = $q.defer();

        if (groupCodes && Array.isArray(groupCodes)) {
            groupCodes = groupCodes.join(',');
        }
        var parmaters = {
            group_codes: groupCodes,
            external_channel_codes: externalChannelCodes
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/logs', 'GET', parmaters).then(function (data) {
            if (data && data.data && data.status == 200) {
                deferred.resolve(data.data.data.logs);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandTimesheetSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/timesheet', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTimesheetBusinessSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/timesheet/business/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBusinessTimesheetSettings = function (brandId, attributes) {
        var deferred = $q.defer();

        var payLoad = {attributes: attributes.join(',')};

        _protected.request('brands/' + brandId + '/business/settings', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBusinessTimesheetSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/business/settings', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBusinessTcafSettings = function (brandId, attributes) {
        var deferred = $q.defer();

        var payLoad = {attributes: attributes.join(',')};

        _protected.request('brands/' + brandId + '/business/settings/tcaf', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBusinessTcafSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/business/settings/tcaf', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandTcafBusinessSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/business/tcaf/settings', 'GET')
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBusinessTcafReasons = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/timesheet_adjustments/clock_edit_reasons', 'GET')
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBusinessTcafReasons = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/timesheet_adjustments/clock_edit_reasons', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPayrunsTypesSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPayrunsTree = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payruns/tree', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    })[0];


    self.getNotificationPermittedUsers = function (brandId, notificationType) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payruns/notifications/' + notificationType + '/permitted_users', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPayrunsNotificationsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payruns/notifications', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBrandPayrunsNotificationsSettings = function (brandId, settings) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payruns/notifications', 'PUT', settings)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.getPayrunsTypeYears = function (brandId, payrunTypeId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/years', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPayruns = function (brandId, payrunTypeId, selectedYear) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns', 'GET', {year: selectedYear})
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.exportPayRunDatasheet = function (brandId, payrunTypeId, payrunId, brandPaysheets) {
        var deferred = $q.defer();

        if (!brandId || !payrunTypeId || !payrunId) {
            throw 'brandId and payrunTypeId and payrunId are required'
        }

        var params = {
            brand_paysheets: brandPaysheets
        };

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + "/report/export", 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.exportPayRun = function (brandId, payrunTypeId, payrunId, brandPaysheets) {
        var deferred = $q.defer();

        var params = {
            brand_paysheets: brandPaysheets
        };

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + "/export", 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.startPayRun = function (brandId, payrunTypeId, payrunId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + "/start", 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generatePayRun = async (brandId, payrunTypeId, payrunId) => {
        if (!brandId) {
            throw "Brand id is required";
        }
        const response = await _protected.request(`brands/${brandId}/payrun_types/${payrunTypeId}/payruns/${payrunId}/payslips/generate`, 'POST');
        if (response?.data.data && response.status === 200) {
            return response.data.data;
        } else {
            throw response;
        }
    };

    self.finalizePayRun = function (brandId, payrunTypeId, payrunId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + "/finalize", 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayRunDetails = function (brandId, payrunTypeId, payrunId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayRunBasicDetails = function (brandId, payrunTypeId, payrunId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/basic_info', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayRunPayDatasheets = function (brandId, payrunTypeId, payrunId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/paysheets', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.paysheets || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeePaymentDetails = function (brandId, payrunTypeId, payrunId, userId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/users/' + userId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getEmployeePayslip = function (brandId, payrunTypeId, payrunId, userId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/payrun_types/' + payrunTypeId + '/payruns/' + payrunId + '/users/' + userId +'/payslip', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandTimesheetSettings = function (brandId, settings) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/timesheet', 'PUT', settings)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateExtendedClockTips = function (brandId, usersId, clockId, day, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + usersId + '/clocks/' + clockId + '/extension/tips?day=' + day, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getDataPassSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/data_pass', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateDataPassSettings = function (brandId, settings) {
        var deferred = $q.defer();

        var payload = {
            data_pass_settings: settings
        };

        _protected.request('brands/' + brandId + '/settings/data_pass', 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTimeSheetConflicts = function (brandId, dataDate, type) {
        var deferred = $q.defer();

        var payload = {
            day: dataDate.format("YYYY-MM-DD"),
            type: type,
            status: 'PENDING'
        };

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/timesheets/conflicts', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.resolveTimeSheetConflicts = function (brandId, dataDate, conflictId, type, data) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + "brands/" + brandId + "/timesheets/conflicts/" + conflictId + "/resolve?type=" + type, "POST", data)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.archiveTimeSheetConflicts = function (brandId, conflictId, clockEditReason) {
        var deferred = $q.defer();
        var params = {};

        if (clockEditReason) {
            params['clock_edit_reason_id'] = clockEditReason.id;
        }

        _protected.request(apiUpdatedUrl + "brands/" + brandId + "/timesheets/conflicts/" + conflictId, "DELETE", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTimesheetOfflineConflictsIntervals = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/timesheet/offline_mode/history", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeShiftConsentsCount = async (brandId, params) => {
        let response = await _protected.request(`employees/brands//${brandId}/shifts/consents/count`, "GET", params);
        if (response?.status !== 200) {
            throw (response);
        }
        return response.data.data;
    }

    self.getEmployeeClockConsentDetails = function (brandId, clockId) {
        var deferred = $q.defer();

        if (!brandId || !clockId) {
            throw 'brandId and clockId are required'
        }

        _protected.request('brands/' + brandId + '/clocks/' + clockId + '/consents', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.consents) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getRemoteClocks = (brandId, day, type) =>{
        let deferred = $q.defer();

        _protected.request(`${apiUpdatedUrl}brands/${brandId}/remote_clocks`, 'GET', {day: day, type: type})
            .then((res)=> {
                if (res.status == 200 && res.data?.data) {
                    deferred.resolve(res.data.data || []);
                } else {
                    deferred.reject(res);
                }

            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createRemoteClockTimecard = (brandId, userId, clockId, day, type, payload) => {
        let deferred = $q.defer();

        _protected.request(`${apiUpdatedUrl}brands/${brandId}/users/${userId}/remote_clocks/${clockId}/clocks?type=${type}&day=${day}`, 'POST', payload)
            .then((res) => {
                if (res.status == 200 && res.data?.data) {
                    deferred.resolve(res.data.data || []);
                } else {
                    deferred.reject(res);
                }

            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.archiveRemoteClock = (brandId, userId, clockId) => {
        let deferred = $q.defer();

        _protected.request(`${apiUpdatedUrl}brands/${brandId}/users/${userId}/remote_clocks/${clockId}`, 'DELETE')
            .then((res) => {
                if (res.status == 200 && res.data?.data) {
                    deferred.resolve(res.data.data || []);
                } else {
                    deferred.reject(res);
                }

            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTipsDistributionSettings = async (brandId) => {
        const response = await _protected.request(`brands/${brandId}/bulk_tips/settings`, 'GET');

        if (response?.data?.data) {
            return response.data.data;
        } else {
            throw response;
        }
    };

    self.getFinalFWWCount = function (brandId, weekStartDate, weekEndDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId and clockId are required'
        }

        const params = {
            from_date: weekStartDate,
            to_date: weekEndDate,
        }

        _protected.request('brands/' + brandId + '/clocks/final_fair_work_week', 'GET', params)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.paid_days) {
                    var penaltiesTotalCount = 0;
                    var penaltiesPendingCount = 0;

                    for (var i in res.data.data.paid_days) {
                        var day = res.data.data.paid_days[i];
                        for (var j in day.users) {
                            var user = day.users[j];
                            for (var b in user.clocks) {
                                penaltiesTotalCount += user.clocks[b].penalties.length;
                                var pendingPenalties = user.clocks[b].penalties.filter(function (penalty) {
                                    return penalty.status === 'PENDING_APPROVAL';
                                })
                                penaltiesPendingCount += pendingPenalties && pendingPenalties.length;
                            }
                        }
                    }

                    deferred.resolve({
                        total: penaltiesTotalCount,
                        pending: penaltiesPendingCount,
                        resolved: penaltiesTotalCount - penaltiesPendingCount,
                    });
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandBreakWaiverSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request(apiUpdatedUrl + 'brands/' + brandId + '/break_waiver_files/settings', 'GET')
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data.break_waiver_files || []);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPaySheetTypesErrors = async (brandId, paysheetTypesId, paysheetsId) => {

        const res = await _protected.request(`${apiUpdatedUrl}brands/${brandId}/paysheet_types/${paysheetTypesId}/paysheets/${paysheetsId}/errors`, 'GET');
        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        } else {
            throw res;
        }
    };
});
PerformanceAggregatorAPI.ShiftTemplatesTypesConstants = {
    NONE: 'NONE'
}
